import { defineSlotRecipe } from '@chakra-ui/react';

export const tableSlotRecipe = defineSlotRecipe({
  className: 'table',
  slots: ['root', 'header', 'columnHeader', 'body', 'row', 'cell'],
  base: {
    root: {
      fontWeight: 500,
      color: 'fg',
    },
    header: {
      position: 'sticky',
      top: 0,
      backgroundColor: 'white',
      zIndex: '1',
    },
    columnHeader: {
      fontFamily: 'heading',
      letterSpacing: 'wider',
      padding: '3 !important',
      fontSize: 'xs',
      border: '0',
      textTransform: 'none',
      color: 'fg.subtle',
      fontWeight: 500,
      borderBottom: '1px solid {colors.border}',
      borderTop: '1px solid {colors.border}',
    },
    cell: {
      padding: '3 !important',
    },
  },
});

export default tableSlotRecipe;
